<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_iv"></a>Acknowledgments</h2>
<div class="sfont">
<p class="indent">The publishers are indebted to the following for permission to reprint selections from their publications:</p>
<p class="indent1">New York Times, Springfield (Mass.) News, New York American, New York World, The Mentor, The (Newark) Sunday Call, The Forum, Strand Magazine, The (Dearborn) Independent, American Magazine, Socony Standard, New York Herald, Scientific American, The Princetonian, Collier’s, New York Journal, McClure’s, Musical Monitor, Musical America, Cosmopolitan, Hearst’s International, Baltimore (Md.) American, New York Mail, American Scrapbook.</p>
</div>
<p class="center"><em class="italic">The editor wishes to thank Mr. Norman R. Speiden, curator of the Thomas Alva Edison Foundation, West Orange, New Jersey, for his kind assistance in the preparation of this volume.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Acknowl.vue?6bf1f2d8